/** What a table shows for a value that does not exist yet. Words, so it cannot be misread as a mark. */
export const MISSING = 'n/a';

export function fmtScore(value: number | null | undefined): string {
  return value === null || value === undefined ? MISSING : Math.round(value).toString();
}

export function fmtRelative(iso: string | null | undefined, now = Date.now()): string {
  if (!iso) return MISSING;
  const diff = now - new Date(iso).getTime();
  const minutes = Math.round(diff / 60_000);
  if (Math.abs(minutes) < 1) return 'just now';
  if (Math.abs(minutes) < 60) return minutes > 0 ? `${minutes} min ago` : `in ${-minutes} min`;
  const hours = Math.round(minutes / 60);
  if (Math.abs(hours) < 24) return hours > 0 ? `${hours} h ago` : `in ${-hours} h`;
  return new Date(iso).toLocaleDateString('en-IN', {
    day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit', timeZone: 'Asia/Kolkata',
  });
}

export function fmtDuration(seconds: number): string {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m}:${s.toString().padStart(2, '0')}`;
}

/** Where an applicant came from. One map, because three copies of it had already drifted apart. */
export const SOURCE_LABEL: Record<string, string> = {
  apply_link: 'Apply link', wellfound_email: 'Wellfound mailbox', wellfound_sync: 'Wellfound sync', manual: 'Added by hand', upload: 'Excel or CSV', resume: 'Resume upload',
};

export const AGENT_LABEL: Record<string, string> = {
  intake: 'Intake', match: 'Match', call: 'Call', integrity: 'Integrity', evaluate: 'Evaluate',
};

export const AGENT_HINT: Record<string, string> = {
  intake: 'Reads every link and resume and builds one profile',
  match: 'Scores the profile against the job rubric and books the first call',
  call: 'Writes candidate-specific questions, places the screening call and handles retries',
  integrity: 'Looks for proxy, coaching, reading and copying signals',
  evaluate: 'Scores the transcript and recommends a next step',
};
